import { render, staticRenderFns } from "./TotalTypesMultipleRowsTable.vue?vue&type=template&id=680b07e5&scoped=true&"
import script from "./TotalTypesMultipleRowsTable.vue?vue&type=script&lang=js&"
export * from "./TotalTypesMultipleRowsTable.vue?vue&type=script&lang=js&"
import style0 from "./TotalTypesMultipleRowsTable.vue?vue&type=style&index=0&id=680b07e5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680b07e5",
  null
  
)

export default component.exports